import React, { useEffect }  from 'react';
import './App.css';
import Viewer from './components/Viewer'
import weChatShare from './utils/weChatShare';

function App() {
  useEffect(() => {
    weChatShare.attach({
      title: 'WEY-VV7 3D虚拟展厅',
      desc: 'WEY是名字 · 亦是铭志。WEY-VV7，豪华之美，亦是成人之美。',
      imgUrl: `${window.location.protocol}//gizmohub.oss-cn-shenzhen.aliyuncs.com/demo/pics/exterior.jpeg`,
    });
  }, [])
  return (
    <div className="App">
      <Viewer />
    </div>
  )
}

export default App;
